module.exports = __webpack_public_path__ + "static/media/133.5a9ff18f.jpg";